module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-baby-BR.c7eb717.webp";